module.exports = __webpack_public_path__ + "img/ai.61c09b79.svg";